import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import * as React from 'react';
import { handleDynamicCalltracking } from '../../utils/handleDynamicCalltracking';
export var useDynamicPhone = function useDynamicPhone(_ref) {
  var formattedPhone = _ref.formattedPhone,
    notFormattedPhone = _ref.notFormattedPhone,
    siteBlockId = _ref.siteBlockId,
    httpApi = _ref.httpApi,
    logger = _ref.logger,
    placeType = _ref.placeType,
    pageType = _ref.pageType,
    platformType = _ref.platformType,
    announcementId = _ref.announcementId,
    queryString = _ref.queryString;
  var _React$useState = React.useState(formattedPhone),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    dynamicPhone = _React$useState2[0],
    setPhone = _React$useState2[1];
  var _React$useState3 = React.useState(notFormattedPhone ? "tel:".concat(notFormattedPhone) : ''),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    linkPhone = _React$useState4[0],
    setLinkPhone = _React$useState4[1];
  var _React$useState5 = React.useState(!siteBlockId),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    responseEnded = _React$useState6[0],
    setResponseEnded = _React$useState6[1];
  var handleDynamicPhone = React.useCallback(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _yield$handleDynamicC, phone, _notFormattedPhone;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          if (!siteBlockId) {
            _context.next = 10;
            break;
          }
          _context.next = 4;
          return handleDynamicCalltracking({
            blockId: siteBlockId,
            platformType: platformType,
            pageType: pageType,
            placeType: placeType,
            httpApi: httpApi,
            logger: logger,
            announcementId: announcementId,
            queryString: queryString
          });
        case 4:
          _yield$handleDynamicC = _context.sent;
          phone = _yield$handleDynamicC.phone;
          _notFormattedPhone = _yield$handleDynamicC.notFormattedPhone;
          if (phone) {
            setPhone(phone);
          }
          if (_notFormattedPhone) {
            setLinkPhone("tel:+".concat(_notFormattedPhone));
          }
          setResponseEnded(true);
        case 10:
          _context.next = 16;
          break;
        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](0);
          setResponseEnded(true);
          logger.error(_context.t0, {
            domain: 'handleDynamicCalltracking'
          });
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 12]]);
  })), [siteBlockId, placeType, queryString, announcementId]);
  React.useEffect(function () {
    handleDynamicPhone();
  }, [handleDynamicPhone]);
  return React.useMemo(function () {
    return {
      dynamicPhone: dynamicPhone,
      responseEnded: responseEnded,
      linkPhone: linkPhone
    };
  }, [dynamicPhone, responseEnded, linkPhone]);
};